<template>
  <div>
    <template v-if="picker">
      <v-color-picker dot-size="12" width="150" @update:color="selectedColor" hide-inputs show-swatches swatches-max-height="200"></v-color-picker>
    </template>
    <template v-else>
      <v-btn dark icon v-for="color in arrayColor1" :key="color" v-on:click="changeColorTheme(color)">
        <v-icon :color="color">mdi-circle</v-icon>
      </v-btn>
      <v-btn dark icon v-for="color in arrayColor2" :key="color" v-on:click="changeColorTheme(color)">
        <v-icon :color="color">mdi-circle</v-icon>
      </v-btn>
      <v-btn dark icon v-for="color in arrayColor3" :key="color" v-on:click="changeColorTheme(color)">
        <v-icon :color="color">mdi-circle</v-icon>
      </v-btn>
      <v-btn dark icon v-for="color in arrayColor4" :key="color" v-on:click="changeColorTheme(color)">
        <v-icon :color="color">mdi-circle</v-icon>
      </v-btn>
    </template>
  </div>
</template>

<script>
  import { themeColors } from "../../../colors.js";

  export default {
    name: "ColorThemes",
    props: {
      picker: {
        type: Boolean,
        default: false,
        require: false,
      },
    },
    data() {
      return {
        arrayColor1: themeColors.palete1,
        arrayColor2: themeColors.palete2,
        arrayColor3: themeColors.palete3,
        arrayColor4: themeColors.palete4,
      };
    },
    mounted() {
      if (localStorage.getItem("themeColor") !== null) {
        this.changeColorTheme(localStorage.getItem("themeColor"));
      }
    },
    methods: {
      changeColorTheme(String) {
        localStorage.setItem("themeColor", String);
        this.$vuetify.theme.themes.light.primary = String;
        this.$vuetify.theme.themes.light.accent = String;
        this.$vuetify.theme.themes.dark.primary = String;
        this.$vuetify.theme.themes.dark.accent = String;
      },
      selectedColor(string) {
        /* console.log(string.hex); */
      },
    },
  };
</script>

<style scoped></style>
